/**
 * Enum of states used by the file importer.
 */
export enum ImportState {
  Cancelled = 'cancelled',
  Completed = 'completed',
  InProgress = 'in-progress',
  Ready = 'ready'
}
